import { API_URL as baseApiUrl } from "@/config/env";

export const sizes = {
	w650: 650,
	w450: 450,
	w300: 300,
	w270: 270,
	w250: 250,
	w200: 200,
	w150: 150,
	h35: 35,
};

export const fileTransferUrls = {
  getFolderIdByName: baseApiUrl + "Moveit/GetFolderIdByName_Rv3?",
  getFolderContent: baseApiUrl + "Moveit/GetFolderContent?",
  downloadFile: baseApiUrl + "Moveit/DownloadFile?",
  deleteFile: baseApiUrl + "Moveit/DeleteFile?",
  uploadFile: baseApiUrl + "Moveit/UploadFile",
  processFile: baseApiUrl + "Moveit/SaveFileToDatabase",
  getQuotaFileStatus :baseApiUrl + "Admin/GetQuotaFileStatus",
  getQuotaFileGenerateStatus :baseApiUrl + "Admin/GetQuotaFileGenerateStatus",
  repositoryFileUpload: baseApiUrl + "Moveit/UploadRepositoryFiles",
  getRepositoryFiles: baseApiUrl + "Moveit/GetRepositoryFiles",
  downloadRepositoryFile :baseApiUrl + "Moveit/DownloadRepositoryFile",
  deleteRepositoryFile: baseApiUrl + "Moveit/DeleteRepositoryFile",
  getScenarioByCountry: baseApiUrl + "Moveit/GetScenarioByCountry?",
};
